module.exports = __webpack_public_path__ + "img/EUR.119ca728.svg";